import React from 'react'

export default function MyButton({ text, onClickAction }) {
  return (
    <button onClick={onClickAction} className='py-2 px-5 mt-4 p-3 bg-gradient-to-r from-blue-700  to-sky-600 text-white transition-all duration-200 hover:scale-105 rounded-full'>
      {text}
    </button>
  )
}
